import React, {
  Dispatch,
  SetStateAction,
  useLayoutEffect,
  useRef,
} from 'react';
import { HydratedRecallCode } from '../../../common/types/compoundModels';
import moment from 'moment';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  recallCode?: HydratedRecallCode;
}

const RecallCodeDetailModal = ({ isOpen, setIsOpen, recallCode }: IProps) => {
  const modal = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const { current } = modal;
    if (current)
      M.Modal.init(current, {
        onCloseEnd: () => setIsOpen(false),
      });

    return () => {
      if (current) M.Modal.getInstance(current)?.destroy();
    };
  }, []);

  const getModal = () =>
    modal.current ? M.Modal.getInstance(modal.current) : null;

  useLayoutEffect(() => {
    const modal = getModal();
    if (modal) isOpen ? modal.open() : modal.close();
  }, [isOpen]);

  return (
    <div ref={modal} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center blue-text text-darken-4">
            {recallCode?.formFactor}
          </h5>
          <h6 className="center">NDC: {recallCode?.ndcWithDashes}</h6>
        </div>
        <div className="divider" />
        {recallCode?.expirations && (
          <div className="row">
            <h6 className="center">
              <b>Expirations</b>
            </h6>
            <div
              style={{
                display: 'flex',
                justifySelf: 'stretch',
                flexWrap: 'wrap',
                gap: '12px',
                fontSize: '18px',
              }}
            >
              {recallCode?.expirations.map(({ expiration }) => (
                <span>{moment(expiration).format('MM/DD/YY')}</span>
              ))}
            </div>
          </div>
        )}
        {recallCode?.lotNumbers && (
          <>
            <div className="divider" />
            <div className="row">
              <h6 className="center">
                <b>Lot Numbers</b>
              </h6>
              <div
                style={{
                  display: 'flex',
                  justifySelf: 'stretch',
                  flexWrap: 'wrap',
                  gap: '12px',
                  fontSize: '18px',
                }}
              >
                {recallCode?.lotNumbers?.map(({ lotNumber }) => (
                  <span>{lotNumber}</span>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RecallCodeDetailModal;
